"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.responseExchangePointSchema = exports.requestExchangePointSchema = exports.responsePartnerPointSchema = exports.requestPartnerPointSchema = void 0;
var zod_1 = require("zod");
exports.requestPartnerPointSchema = zod_1.z.object({
    partnerType: zod_1.z.string(),
});
exports.responsePartnerPointSchema = zod_1.z.object({
    memberNo: zod_1.z.number(),
    userIdentifier: zod_1.z.string(),
    balance: zod_1.z.number(),
});
exports.requestExchangePointSchema = zod_1.z.object({
    partnerType: zod_1.z.string(),
    amount: zod_1.z.number(),
});
exports.responseExchangePointSchema = zod_1.z.object({
    exchangeAmount: zod_1.z.number(),
    yanoljaBalance: zod_1.z.number(),
    partnerBalance: zod_1.z.number(),
});
var ExchangeErrorCodeMessageMap = {
    INVALID_REQUEST: '잘못된 요청입니다.',
    EXCHANGE_LIMIT_TRY_EXCEEDED: '전환 시도 횟수를 초과하였습니다.',
    EXCHANGE_LIMIT_AMOUNT_EXCEEDED: '전환 금액을 초과하였습니다.',
    INVALID_EXCHANGE_AMOUNT: '금액 초과 외 금액 정책 오류입니다.',
    INTERNAL_SERVER_ERROR: '서버 오류입니다.',
    FEATURE_FLAG_LOCKED: '점검중 입니다.',
};
